import * as ts from "../common/Translator";
import {payInvoice} from "../actions/PGWUtil";
import {SignDocuments} from "../actions/EInvoiceSignerUtils";

export class ActionButtonWidget {
    constructor(entityType, actionId, actionTitle, actionCustomization) {
        this.actionId = actionId;
        this.entityType = entityType;
        this.actionTitle = actionTitle;
        this.actionCustomization = actionCustomization;
    }

    render(metaData, presenter, container) {
        let that = this;
        let titleToShow = ts.translateId(that.actionId);
        if (that.actionTitle && (that.actionTitle.resourceId || that.actionTitle.arabicText || that.actionTitle.englishText))
            titleToShow = ts.translateNaMaText(that.actionTitle);
        let actionBtn = $(`<button class=" btn btn-outline-primary mx-2 my-1 rounded-sm px-1 py-1" id="${that.actionId}">${titleToShow}</button>`);
        container.append(actionBtn);
        actionBtn.click((e) => {
            if (that.actionId === "PayInvoice")
                payInvoice();
            if (that.actionId === "SignDocuments")
                SignDocuments(false);
            if (that.actionId === "SignSelectedDocuments")
                SignDocuments(true);
            else
                presenter.callGUIAction(that.actionId, metaData, that.actionCustomization)
        });
        return actionBtn;
    }
}
